import { useMutation } from "@tanstack/react-query";
import type { ColumnFiltersState } from "@tanstack/react-table";
import { apiClient } from "../../../../zodios/client";
import { clientToServerFiltering } from "../../../../components/table/utils";
import { useDates } from "../../../../dates/DatesContext";
import { useAppSelector } from "../../../../redux/hooks";

export const useV4ProductAdReportExport = (filters: ColumnFiltersState, adId?: number, productId?: number) => {
  const marketPlace = useAppSelector((state) => state.marketPlace.marketPlace);
  const { start, end } = useDates();
  return useMutation({
    mutationFn: async () =>
      await apiClient.getV4ProductAdReportExport({
        queries: {
          start_date: start.format("YYYY-MM-DD"),
          end_date: end.format("YYYY-MM-DD"),
          marketplace: marketPlace,
          filters: clientToServerFiltering(
            filters,
            productId !== undefined ? [{ id: "gvproduct_id", value: { op: "=", value: productId } }] : [],
          ),
          ...(adId !== undefined && { advertisement_id: adId }),
        },
        responseType: "blob",
      }),
  });
};
